import type { IOffer } from "@bbj-types/offer";
import type { ISettingValue, ISettingValueMaster } from "@bbj-types/setting";
import OpenInNewIcon from "@mui/icons-material/OpenInNewOutlined";
import { Stack, Tooltip, Typography, type TypographyProps } from "@mui/material";
import { isInternalOfferSource, toSettingOfferSource } from "@root/utils/enums/offer";
import clsx from "clsx";
import { useMemo } from "react";
import { ChipStyled, classes } from "./styles";

export const formatSource = (offer: IOffer, statusSourceOffer: ISettingValue[]) => {
  return statusSourceOffer.find((source) => source.value === toSettingOfferSource(offer.source))?.label;
};

export const getOfferPeSource = (offer: IOffer) =>
  `Pôle Emploi - ${offer.externalId?.split("-")[1] ? offer.externalId.split("-")[1] : offer.offerId}`;

interface ChipSourceLabelProps extends TypographyProps {
  offer: IOffer;
  statusSourceOffer: ISettingValueMaster[] | ISettingValue[];
  shopOfferPEId?: boolean;
  expired?: boolean;
}

export const ChipSourceLabel = ({ offer, statusSourceOffer, className, expired, ...props }: ChipSourceLabelProps) => {
  const label = useMemo(() => {
    return formatSource(offer, statusSourceOffer);
  }, [offer, statusSourceOffer]);
  return offer.url ? (
    <Tooltip title="Voir l'offre sur le site">
      <ChipStyled
        className={classes.root}
        component="a"
        size="small"
        label={
          <Stack className={classes.content}>
            <OpenInNewIcon className={classes.icon} />
            <Typography className={clsx(classes.label, className)} variant="body2SemiBold" {...props}>
              {label}
            </Typography>
          </Stack>
        }
        aria-label="externalLink"
        href={offer.url}
        target="_blank"
        rel="noreferrer noopener"
        color={isInternalOfferSource(offer.source) ? "primary" : "blue"}
        sx={(theme) => ({
          background: expired ? theme.palette.gray.dark : "",
        })}
      />
    </Tooltip>
  ) : (
    <ChipStyled
      className={classes.root}
      size="small"
      label={
        <Typography variant="body2SemiBold" sx={{ color: "white !important" }} {...props}>
          {label}
        </Typography>
      }
      color={isInternalOfferSource(offer.source) ? "primary" : "blue"}
      sx={(theme) => ({
        background: expired ? theme.palette.gray.dark : "",
      })}
    />
  );
};
